module.exports = __webpack_public_path__ + "img/language-es.a5d0118f.png";